import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "modal-close",
  "use": "modal-close-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"modal-close\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.0001 17.4143L26.293 27.7072L27.7072 26.293L17.4143 16.0001L27.7072 5.70721L26.293 4.293L16.0001 14.5859L5.70718 4.29297L4.29297 5.70718L14.5859 16.0001L4.29297 26.293L5.70718 27.7072L16.0001 17.4143Z\" fill=\"#424242\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol